import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getDomainBrandingConfig, mergeBrandingConfig } from "../../utils/domainBranding";
import { hasAccessTokenSync } from "src/Services/tokenService";

const Logo = ({ config, profile, logoURL }) => {
  const [error, setError] = useState(false);
  const [logoSrc, setLogoSrc] = useState("");
  const [logoBackgroundColor, setLogoBackgroundColor] = useState("transparent");
  
  const handleImageError = () => {
    setError(true);
  };
  
  useEffect(() => {
    let accessToken = hasAccessTokenSync();
    
    // Get domain config and merge with API config
    const domainConfig = getDomainBrandingConfig();
    const mergedConfig = mergeBrandingConfig(domainConfig, config);
    
    const logo = mergedConfig?.logo;
    // Get background color from config (default to transparent)
    // Priority: logoBackgroundColor > BrandColor (for header alignment) > transparent
    const bgColor = mergedConfig?.logoBackgroundColor || 
                    mergedConfig?.skin?.BrandColor || 
                    "transparent";
    
    setLogoBackgroundColor(bgColor);
    
    // if ((logo === undefined || logo === null) && accessToken !== undefined) {
    //   const storedLogo = Cookies.get("logo");
    //   setLogoSrc(storedLogo);
    // } else {
    //   setLogoSrc(logo);
    // }
    if (accessToken) {
      setLogoSrc(logo);
    } else if (logo) {
      // Allow logo to show even without access token (for public pages)
      setLogoSrc(logo);
    }
  }, [config]);
  useEffect(() => {
    if (logoURL) {
      setLogoSrc(logoURL);
      setError(false);
    }
  }, [logoURL]);
  return (
    <>
      {error || logoSrc === undefined || logoSrc === null ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="150"
          viewBox="0 0 980 458"
          fill="var(--primaryColor)"
        >
          <path d="M980 0H0V458H980V0Z" fill="var(--primaryColor)" />
          <path
            opacity="0.66"
            d="M410.641 153.56L387.221 143.25V251.39L419.861 177.29C421.769 172.919 421.87 167.97 420.143 163.524C418.416 159.078 415 155.496 410.641 153.56V153.56Z"
            fill="white"
          />
          <path
            opacity="0.66"
            d="M103.9 272.72C101.978 277.087 101.868 282.038 103.595 286.486C105.322 290.934 108.745 294.514 113.11 296.44L136.53 306.76V198.62L103.9 272.72Z"
            fill="white"
          />
          <path
            opacity="0.66"
            d="M214.171 67.02C209.8 65.1118 204.851 65.0103 200.405 66.7377C195.959 68.4651 192.377 71.881 190.441 76.24L180.121 99.6599H288.261L214.171 67.02Z"
            fill="white"
          />
          <path
            opacity="0.66"
            d="M309.59 382.99C313.961 384.898 318.91 384.999 323.356 383.272C327.802 381.544 331.384 378.128 333.32 373.77L343.63 350.35H235.5L309.59 382.99Z"
            fill="white"
          />
          <path
            d="M136.53 332.35C136.543 337.12 138.444 341.69 141.817 345.063C145.19 348.436 149.76 350.337 154.53 350.35H235.53L136.53 306.76V332.35Z"
            fill="white"
          />
          <path
            d="M154.53 99.6597C149.76 99.6729 145.19 101.574 141.817 104.946C138.444 108.319 136.543 112.89 136.53 117.66V198.66L180.12 99.6597H154.53Z"
            fill="white"
          />
          <path
            d="M369.221 350.35C373.991 350.336 378.561 348.436 381.934 345.063C385.307 341.69 387.208 337.12 387.221 332.35V251.35L343.631 350.35H369.221Z"
            fill="white"
          />
          <path
            d="M387.221 117.66C387.208 112.89 385.307 108.319 381.934 104.946C378.561 101.574 373.991 99.6729 369.221 99.6597H288.221L387.221 143.25V117.66Z"
            fill="white"
          />
          <path
            d="M182.94 205.81H176.391V224.75H182.94C190.194 224.75 193.821 221.593 193.821 215.28C193.821 208.966 190.194 205.81 182.94 205.81Z"
            fill="white"
          />
          <path
            d="M288.26 99.6597H180.12L136.53 198.66V306.81L235.53 350.4H343.66L387.25 251.4V143.25L288.26 99.6597ZM207.67 234.02C203.137 238.446 196.607 240.663 188.08 240.67H176.39V265.86H156.64V189.86H188.08C196.614 189.86 203.144 192.076 207.67 196.51C212.197 200.943 214.464 207.19 214.47 215.25C214.47 223.33 212.204 229.586 207.67 234.02V234.02ZM269.99 206.61H253.81V265.86H234.06V206.61H217.81V189.89H270L269.99 206.61ZM350.89 265.86L344.35 222.13L326.41 265.86H318.55L301.55 222.13L295 265.86H275.35L288.25 189.86H307.81L323.03 230.36L338.14 189.86H357.69L370.58 265.86H350.89Z"
            fill="white"
          />
          <path
            d="M465.121 216.437H449.404V282.848H465.121V256.508C468.489 260.394 473.757 262.208 478.852 262.208C491.979 262.208 501.047 251.499 501.047 238.718C501.047 226.023 491.893 214.969 478.68 214.969C473.498 214.969 468.144 217.042 465.294 221.446H465.121V216.437ZM474.707 228.614C481.098 228.614 484.811 233.191 484.811 238.632C484.811 244.245 481.098 248.563 474.707 248.563C468.317 248.563 464.603 244.245 464.603 238.632C464.603 233.191 468.317 228.614 474.707 228.614ZM525.974 229.391H534.869V216.437H525.974V203.138H510.256V216.437H505.161V229.391H510.256V260.74H525.974V229.391ZM536.368 260.74H553.208L558.648 223.26H558.821L573.761 260.74H580.497L596.129 223.26H596.301L601.051 260.74H617.978L608.133 195.624H591.292L577.302 230.427L564.089 195.624H547.422L536.368 260.74ZM647.979 228.614C654.37 228.614 658.083 233.191 658.083 238.632C658.083 244.245 654.37 248.563 647.979 248.563C641.588 248.563 637.875 244.245 637.875 238.632C637.875 233.191 641.588 228.614 647.979 228.614ZM673.283 216.437H657.565V220.755C654.283 216.869 648.929 214.969 643.834 214.969C630.707 214.969 621.639 225.85 621.639 238.545C621.639 251.24 630.88 262.208 644.006 262.208C649.188 262.208 654.629 260.222 657.392 255.817H657.565V260.74H673.283V216.437ZM699.419 216.437H683.701V260.74H699.419V237.768C699.419 232.241 701.232 227.491 707.623 227.491C715.395 227.491 714.704 234.918 714.704 239.15V260.74H730.422V233.364C730.422 222.482 725.672 214.969 713.754 214.969C707.623 214.969 703.218 216.783 699.591 222.137H699.419V216.437ZM757.982 229.391H766.877V216.437H757.982V203.138H742.265V216.437H737.169V229.391H742.265V260.74H757.982V229.391ZM787.634 216.437H771.916V260.74H787.634V242.863C787.634 235.264 789.793 229.477 798.515 229.477C800.933 229.477 803.006 229.737 805.165 230.946V215.833H802.142C796.011 215.833 790.829 218.251 787.807 223.691H787.634V216.437ZM834.193 228.614C840.583 228.614 844.297 233.191 844.297 238.632C844.297 244.245 840.583 248.563 834.193 248.563C827.802 248.563 824.089 244.245 824.089 238.632C824.089 233.191 827.802 228.614 834.193 228.614ZM859.496 216.437H843.779V220.755C840.497 216.869 835.143 214.969 830.048 214.969C816.921 214.969 807.853 225.85 807.853 238.545C807.853 251.24 817.094 262.208 830.22 262.208C835.402 262.208 840.843 260.222 843.606 255.817H843.779V260.74H859.496V216.437Z"
            fill="white"
          />
        </svg>
      ) : (
        <div
          style={{
            backgroundColor: logoBackgroundColor,
            padding: logoBackgroundColor !== "transparent" ? "8px" : "0",
            borderRadius: logoBackgroundColor !== "transparent" ? "0px" : "0",
            display: "inline-block",
          }}
        >
          <img
            src={logoSrc}
            // width={"150px"}
            // height={"70px"}
            style={{
              maxWidth: "150px",
              maxHeight: "70px",
              width: "150px",
              height: "70px",
              objectFit: "contain",
              objectPosition: "center center",
              display: "block",
            }}
            alt="logo"
            key={Date.now()}
            onError={handleImageError}
          />
        </div>
      )}
    </>
  );
};

export default Logo;
